export default __webpack_public_path__ + "static/media/Img1.f3e10bd7.png";